<script>
  import { onMount } from 'svelte';
  import { push } from 'svelte-spa-router';
  import { isAuthenticated } from '@dopry/svelte-auth0';
  import { Container } from 'sveltestrap';

  onMount(async () => {
    if (!$isAuthenticated) push('/');
  });
</script>

<h5>&nbsp;> Support</h5>
<br />
<Container>support stuff...</Container>
